import { PlusOutlined } from "@ant-design/icons";
import {
  ComponentPagination,
  SearchFilter,
  SelectedFilter,
  SharedButton,
  StyledListPage,
  ComponentHeader,
  StyledInnerListPage,
  SharedIconButton,
  PlusIcon,
} from "@components";

import { cdicCouponCategory, PATH_CREATE_CDIC_PROGRAM, PATH_CREATE_SERVICE_NAME } from "@configs";
import { CouponProgramTable } from "@modules/coupon/ProgramTable";
import { selectApp } from "@redux";
import { useProgramListPage } from "@utils";
import { Col, Row, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";

export const PageProgramList = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { mobile } = useSelector(selectApp);

  const {
    data,
    total,
    page,
    filters,
    date,
    refetch,
    handlePagination,
    changeFilter,
    searchText,
    handleClearSearch,
  } = useProgramListPage();

  const goToCreate = () => history.push(PATH_CREATE_CDIC_PROGRAM);
  const goToCreateService = () => history.push(PATH_CREATE_SERVICE_NAME);

  const button = (
    <>
      {mobile ? (
        <Tooltip title={t("page.add_new_coupon_family")}>
          <SharedIconButton type="primary" ghost icon={<PlusIcon />} onClick={goToCreate} />
        </Tooltip>
      ) : (
        <Row gutter={8}>
          <Col>
            <Tooltip title={t("page.add_new_service")}>
              <SharedButton
                type="primary"
                ghost
                icon={<PlusOutlined />}
                size="middle"
                onClick={goToCreateService}
              >
                {t("page.add_service")}
              </SharedButton>
            </Tooltip>
          </Col>
          <Col>
            <Tooltip title={t("page.add_new_coupon_family")}>
              <SharedButton
                type="primary"
                ghost
                icon={<PlusOutlined />}
                size="middle"
                onClick={goToCreate}
              >
                {t("page.add_cf")}
              </SharedButton>
            </Tooltip>
          </Col>
        </Row>
      )}
    </>
  );

  return (
    <>
      <ComponentHeader title={t("page.cdic_program_management")} />
      <StyledListPage>
        <StyledInnerListPage>
          <SearchFilter
            actionBtn={button}
            filter={cdicCouponCategory}
            callbackFun={changeFilter}
            searchText={searchText}
            searchInputPlaceholder={t("page.search_user_by")}
            selectedOption={filters}
          />
          <SelectedFilter
            handleClearSearch={handleClearSearch}
            selected={filters}
            formDate={date[0]}
            toDate={date[1]}
          />
          <CouponProgramTable data={data} callback={refetch} />
          <ComponentPagination total={total} page={page.page} changePage={handlePagination} />
        </StyledInnerListPage>
      </StyledListPage>
    </>
  );
};
